import React, { useEffect, useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { updateGroup, deleteGroup } from '../../../../redux/actions/settings/groups'
import { ConfirmToast } from '../../tools'

// MUI
import { withStyles } from '@material-ui/styles'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Divider from '@material-ui/core/Divider'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'

// Icons
import DeleteIcon from '@material-ui/icons/Delete'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import GroupAddIcon from '@material-ui/icons/GroupAdd'

const GreenCheckbox = withStyles({
  root: {
    color: '#595959',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const SupGroupEdit = (props) => {
  const {
    classes, groupEdit, handleBackTrack, setSupGroupForm,
    fireUpdateSuccess, fireUpdateFailure, fireDeleteGroupSuccess, fireDeleteGroupFailure
  } = props

  const dispatch = useDispatch()

  const [groupNameValue, setGroupNameValue] = useState('')
  const [groupDescValue, setGroupDescValue] = useState('')

  const [groupSups, setGroupSups] = useState([])
  const [groupSupervisors, setGroupSupervisors] = useState([])
  const [unitInfo, setUnitInfo] = useState({})

  const [noNameError, setNoName] = useState(false)
  const [noDescError, setNoDesc] = useState(false)

  const { selectedUnit: orgUnitInfo } = useSelector(state => state.orgUnits)

  // useEffect(() => {
  //   if (groupEdit) {
  //     if (groupNameValue === '') {
  //       setGroupNameValue(groupEdit.groupName)
  //     }
  //     if (groupDescValue === '') {
  //       setGroupDescValue(groupEdit.groupDesc)
  //     }
  //     const tempSupList = []
  //     groupEdit.supervisors.forEach(sup => {
  //       tempSupList.push(sup.supervisorID)
  //     })
  //     setGroupSups(tempSupList)
  //   }
  // }, [groupEdit, orgUnitInfo, unitInfo, groupDescValue, groupNameValue])

  useMemo(() => {
    if (typeof groupEdit === 'object' && Boolean(groupEdit.groupName)) {
      // if (!groupNameValue) { setGroupNameValue(groupEdit.groupName) }
      setGroupNameValue(groupEdit.groupName)

      // if (!groupDescValue) { setGroupDescValue(groupEdit.groupDesc) }
      setGroupDescValue(groupEdit.groupDesc)

      // if (Array.isArray(groupEdit.supervisors)) {
      setGroupSups(
        groupEdit.supervisors.reduce(
          (arr, supInfo) => {
            if (typeof supInfo === 'object' && Boolean(supInfo) && Boolean(supInfo.supervisorID)) { arr.push(supInfo.supervisorID) }

            return arr
          }, []
        )
      )
      // }
    }
  }, [groupEdit])

  useMemo(() => {
    if (typeof orgUnitInfo === 'object' && Boolean(orgUnitInfo) && Array.isArray(orgUnitInfo.unitSupervisors)) {
      setUnitInfo(orgUnitInfo)
    }
  }, [orgUnitInfo])

  useEffect(() => {
    if (Array.isArray(unitInfo.unitSupervisors)) {
      setGroupSupervisors(unitInfo.unitSupervisors)
    }
  }, [unitInfo.unitSupervisors])

  const handleBackBtn = async () => {
    const backAcknowledged = await ConfirmToast({ msg: 'Are You Sure?', txt: ' Any unsaved progress will be lost.' })
    if (backAcknowledged) {
      handleBackTrack()
    }
  }

  const handleCheckboxes = (supervisorID) => {
    const tempList = [...groupSups]

    if (tempList.includes(supervisorID)) {
      const newSupervisors = tempList.filter((tempInfo) => tempInfo !== supervisorID)
      setGroupSups(newSupervisors)
    } else {
      setGroupSups([...tempList, supervisorID])
    }
  }

  // Pust a character count on the inputs and puts them into a temporary local state
  const handleInputChange = (value) => e => {
    if (value === 'name') {
      if (groupNameValue.length < 50) {
        setGroupNameValue(e.target.value)
      } else {
        setGroupNameValue(groupNameValue.substr(0, 49))
      }
    } else if (value === 'desc') {
      if (groupDescValue.length < 255) {
        setGroupDescValue(e.target.value)
      } else {
        setGroupDescValue(groupDescValue.substr(0, 254))
      }
    }
  }

  // NOTE: This is currently throwing an error if you try to delete more than one supervisor. ->
  // If attempted with a change in either name or desc, it will update those even though it throws and error.
  // Multiple additions to supervisors works as expected, as well as single deletions. Just multiple supervisors to delete seems to break.
  const handleSave = () => {
    const originalSupList = []
    groupEdit.supervisors.forEach((sup) => {
      originalSupList.push(sup.supervisorID)
    })
    const supervisorsToDelete = originalSupList.filter(id => groupSups.indexOf(id) === -1)
    const supervisorsToAdd = groupSups.filter(id => originalSupList.indexOf(id) === -1)
    const groupID = groupEdit.groupID

    if (groupNameValue === '' && groupDescValue === '') {
      setNoName(true)
      setNoDesc(true)
    } else if (groupNameValue === '' && groupDescValue !== '') {
      setNoDesc(false)
      setNoName(true)
    } else if (groupNameValue !== '' && groupDescValue === '') {
      setNoName(false)
      setNoDesc(true)
    } else {
      setNoName(false)
      setNoDesc(false)
      const info = {
        name: groupNameValue,
        desc: groupDescValue,
        supervisorsToAdd,
        supervisorsToDelete
      }
      dispatch(updateGroup(groupID, info, fireUpdateSuccess, fireUpdateFailure))
    }
  }
  const deleteGroupID = (groupID) => {
    dispatch(deleteGroup(groupID, fireDeleteGroupSuccess, fireDeleteGroupFailure))
  }

  return (
    <Grid container direction='row'>
      <Grid container item direction='column' spacing={2} className='m-auto w-100'>

        <Grid container item direction='row' justify='space-between' spacing={2} className='m-auto w-100' alignItems='center'>
          <Grid item className='pl-0'>
            <Button
              size='medium'
              variant='outlined'
              className={`${classes.backButton}
              font-weight-bold`}
              startIcon={<ArrowBackIcon />}
              onClick={handleBackBtn}
            >
              Back
            </Button>
          </Grid>

          <Grid item className='pr-0'>
            <Grid container direction='row' spacing={2} className='m-auto w-100'>
              <Grid item className='pl-0'>
                <Button
                  size='medium'
                  variant='contained'
                  className={`${classes.greenBtn} mr-1 font-weight-bold`}
                  style={{ textTransform: 'none' }}
                  startIcon={<GroupAddIcon />}
                  onClick={() => setSupGroupForm('new')}
                >
                  Create New Group
                </Button>
              </Grid>

              <Grid item className='pr-0'>
                <Button
                  size='medium'
                  variant='contained'
                  className={`${classes.deleteBtn} font-weight-bold`}
                  style={{ textTransform: 'none' }}
                  startIcon={<DeleteIcon />}
                  onClick={() => deleteGroupID(groupEdit.groupID)}
                >
                  Delete Group
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container item direction='row'>
          <Grid item xs={12}>
            <Card raised className={classes.userCard}>
              <CardContent>
                <Grid container direction='row'>
                  <Grid container item direction='column' spacing={2} className='m-auto w-100'>

                    <Grid container item direction='row'>
                      <Grid container item direction='column'>
                        <Grid container item direction='row' justify='space-between'>
                          <Grid item>
                            <Typography
                              gutterBottom
                              variant='h5'
                              style={{ textTransform: 'none', fontWeight: 'bold' }}
                              className='text-primary mt-1'
                            >
                              Edit Group
                            </Typography>
                          </Grid>

                          <Grid item>
                            <Button
                              variant='contained'
                              style={{ textTransform: 'none' }}
                              className={classes.saveButton}
                              onClick={handleSave}
                            >
                              Save Changes
                            </Button>
                          </Grid>
                        </Grid>

                        <Grid container item direction='row'>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container item direction='row'>
                      <Grid item container direction='column'>

                        <Grid item container direction='row' justify='flex-start' wrap='nowrap'>
                          <Grid item>
                            <Typography className='text-primary font-weight-bold mr-2' style={{ textTransform: 'none' }} variant='h6'>
                              Group Unit:
                            </Typography>
                          </Grid>

                          <Grid item>
                            <Typography className='text-muted' variant='h6' style={{ textTransform: 'none', fontWeight: 'bold' }}>
                              {groupEdit.unitName}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid item container direction='row'>
                          <Grid item xs={12}>
                            <Typography gutterBottom variant='caption' style={{ textTransform: 'none' }} className='text-muted'>
                              The unit cannot be altered. To change the unit, please delete the group and create a new one.
                            </Typography>
                          </Grid>
                        </Grid>

                      </Grid>
                    </Grid>

                    <Grid container item direction='row'>
                      <Grid container item direction='column'>
                        <Grid item>
                          <Typography className='text-primary font-weight-bold mr-1' style={{ textTransform: 'none' }} variant='h6'>Group Name:</Typography>
                        </Grid>

                        <Grid item>
                          <Typography gutterBottom variant='caption' style={{ textTransform: 'none' }} className='text-muted mb-1'> {`${groupNameValue.length} of 50`}</Typography>
                        </Grid>

                        <Grid item>
                          <TextField
                            label='Required'
                            variant='outlined'
                            fullWidth
                            error={noNameError}
                            helperText={noNameError ? 'You must enter a name' : ''}
                            className='mt-2'
                            style={{ textTransform: 'none' }}
                            value={groupNameValue}
                            onChange={handleInputChange('name')}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container item direction='row'>
                      <Grid container item direction='column'>
                        <Grid item>
                          <Typography className='text-primary font-weight-bold mr-1' style={{ textTransform: 'none' }} variant='h6'>Group Description:</Typography>
                        </Grid>

                        <Grid item>
                          <Typography gutterBottom variant='caption' style={{ textTransform: 'none' }} className='text-muted mb-1'> {`${groupDescValue.length} of 255`}</Typography>
                        </Grid>

                        <Grid item>
                          <TextField
                            label='Required'
                            error={noDescError}
                            helperText={noDescError ? 'You must enter a description' : ''}
                            multiline
                            className='mt-2'
                            rows={5}
                            fullWidth
                            variant='outlined'
                            style={{ textTransform: 'none' }}
                            value={groupDescValue}
                            onChange={handleInputChange('desc')}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container item direction='row'>
                      <Grid container item direction='column'>
                        <Grid item>
                          <Typography className='text-primary font-weight-bold mr-1' gutterBottom={Boolean(groupSups.length)} style={{ textTransform: 'none' }} variant='h6'>Members:</Typography>
                        </Grid>

                        {
                          !groupSups || !groupSups.length
                            ? (
                              <Grid item>
                                <Typography variant='caption' gutterBottom style={{ textTransform: 'none' }} color='error'>You must select at least one member.</Typography>
                              </Grid>)
                            : (<></>)
                        }

                        <Grid item>
                          <Grid container direction='row' justify='flex-start' spacing={1} className='mx-auto w-100'>
                            {/* Sorted supervisor group member names  */}
                            {
                              groupSupervisors
                                .map((supervisorInfo) => ({
                                  ...supervisorInfo,
                                  fullName: `${supervisorInfo.lastName}, ${supervisorInfo.firstName}`
                                }))
                                .sort((a, b) => a.lastName.localeCompare(b.lastName))
                                .map(({ supervisorID: groupSupervisorID, fullName }) => {
                                  return (
                                    <Grid item key={`supervisor-${groupSupervisorID}`} xs={12} md={6}>
                                      <Grid container direction='row' justify='space-between' alignItems='center'>
                                        <Grid item>
                                          <Typography variant='body1' gutterBottom style={{ textTransform: 'none', fontWeight: 'bold' }}>
                                            {fullName}
                                          </Typography>
                                        </Grid>
                                        <Grid item>
                                          <GreenCheckbox
                                            checked={groupSups.includes(groupSupervisorID)}
                                            size='small'
                                            onClick={() => handleCheckboxes(groupSupervisorID)}
                                          />
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  )
                                })
                            }
                          </Grid>
                        </Grid>

                      </Grid>
                    </Grid>

                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default SupGroupEdit
